const data = {
  tariffeOptions: [
    { code: "1.1b", description: "Sì" },
    { code: "1.2b", description: "No" },
  ],
  compagniaOptions: [
    { code: "2.1", description: "AIG Europe" },
    { code: "2.2", description: "Aioi Nissay Dowa Insurance" },
    { code: "2.3", description: "Allianz" },
    { code: "2.4", description: "Allianz Global Assistance" },
    { code: "2.12", description: "Allianz Viva" },
    { code: "2.6", description: "AmTrust Assicurazioni" },
    { code: "2.7", description: "Arca Assicurazioni" },
    { code: "2.8", description: "ArgoGlobal Assicurazioni" },
    { code: "2.9", description: "Assicuratrice Milanese" },
    { code: "2.10", description: "Assicuratrice Val Piave" },
    { code: "2.11", description: "Assimoco" },
    { code: "2.13", description: "AXA Assicurazioni" },
    { code: "2.14", description: "AXA-MPS Assicurazioni Danni" },
    { code: "2.15", description: "BCC Assicurazioni" },
    { code: "2.16", description: "Bene Assicurazioni" },
    { code: "2.17", description: "BHItalia" },
    { code: "2.18", description: "Banco BPM Assicurazioni" },
    { code: "2.19", description: "CARGEAS Assicurazioni" },
    { code: "2.20", description: "Cattolica Assicurazioni" },
    { code: "2.21", description: "Chubb European Group" },
    { code: "2.22", description: "Crédit Agricole Assicurazioni" },
    { code: "2.24", description: "DARAG" },
    { code: "2.25", description: "Europ Assistance" },
    { code: "2.26", description: "Generali Italia" },
    { code: "2.27", description: "Genertel" },
    { code: "2.28", description: "Genialloyd" },
    { code: "2.29", description: "Global Assistance" },
    { code: "2.30", description: "Groupama Assicurazioni" },
    { code: "2.31", description: "HDI Assicurazioni" },
    { code: "2.5", description: "HDI Italia" },
    { code: "2.32", description: "Helvetia Assicurazioni" },
    { code: "2.33", description: "Helvetia Italia Assicurazioni" },
    { code: "2.34", description: "Intesa Sanpaolo Assicura" },
    { code: "2.58", description: "Intesa Sanpaolo Protezione" },
    { code: "2.35", description: "Italiana Assicurazioni" },
    { code: "2.36", description: "ITAS Mutua" },
    { code: "2.37", description: "Le Assicurazioni di Roma" },
    { code: "2.38", description: "Liberty Mutual Insurance" },
    { code: "2.39", description: "Linear" },
    { code: "2.40", description: "Lloyd's" },
    { code: "2.41", description: "MAPFRE ASISTENCIA" },
    { code: "2.42", description: "Nobis Assicurazioni" },
    { code: "2.43", description: "Prima Assicurazioni" },
    { code: "2.44", description: "QUIXA Assicurazioni" },
    { code: "2.45", description: "Reale Mutua" },
    { code: "2.46", description: "Sara Assicurazioni" },
    { code: "2.47", description: "SIAT" },
    { code: "2.48", description: "SOGESSUR" },
    { code: "2.49", description: "Tiroler Versicherung" },
    { code: "2.50", description: "TUA Assicurazioni" },
    { code: "2.23", description: "UniCredit Allianz Assicurazioni" },
    { code: "2.51", description: "UnipolSai Assicurazioni" },
    { code: "2.52", description: "PiùVera Assicurazioni" },
    { code: "2.53", description: "Verti Assicurazioni" },
    { code: "2.54", description: "Vittoria Assicurazioni" },
    { code: "2.55", description: "XL Insurance Company" },
    { code: "2.56", description: "Zurich Connect" },
    { code: "2.57", description: "Zurich Insurance" },
  ],
  canaleOptions: [
    { code: "3.1", description: "Banca" },
    { code: "3.2", description: "Consulenti Finanziari" },
    { code: "3.3", description: "Agenti" },
    { code: "3.4", description: "Broker" },
    { code: "3.5", description: "Diretto" },
    { code: "3.6", description: "Ente Finanziario" },
  ],
  modDistribuzioneOptions: [
    { code: "5.1", description: "Fisica" },
    { code: "5.2", description: "Online" },
    { code: "5.3", description: "Telemarketing" },
  ],
  mercatoOptions: [
    { code: "6.1", description: "Retail" },
    { code: "6.2", description: "Business" },
  ],
  veicoliOptions: [
    { code: "11.1", description: "Autovetture e Autotassametri" },
    { code: "11.2", description: "Autocarri" },
    { code: "11.3", description: "Motoveicoli" },
    { code: "11.4", description: "Qualsiasi" },
  ],
  prodCommercioOptions: [
    { code: "12.1", description: "Sì" },
    { code: "12.2", description: "No" },
  ],
  tipoAssicurazioneOptions: [
    { code: "16.1", description: "Individuale" },
    { code: "16.2", description: "Collettiva" },
  ],
  combGaranzieTipologiaOptions: [
    { code: "19.1", description: "A formule" },
    { code: "19.2", description: "Modulare" },
    { code: "19.3", description: "Modulare / A formule" },
    { code: "19.4", description: "Pacchetto chiuso" },
    { code: "19.5", description: "Pacchetto chiuso / A formule" },
  ],
  premioTipologiaOptions: [
    { code: "21.1", description: "Annuo" },
    { code: "21.2", description: "Mensile" },
    { code: "21.3", description: "Unico" },
  ],
  frazPremioOptions: [
    { code: "23.1", description: "Mensile" },
    { code: "23.2", description: "Bimestrale" },
    { code: "23.3", description: "Trimestrale" },
    { code: "23.4", description: "Quadrimestrale" },
    { code: "23.5", description: "Semestrale" },
    { code: "23.6", description: "Non previsto" },
  ],
  rischiOptions: [
    { code: "27.1", description: "Responsabilità civile" },
    { code: "27.2", description: "Incendio e Furto" },
    { code: "27.3", description: "Kasko / Collisione" },
    { code: "27.4", description: "Atti vandalici" },
    { code: "27.5", description: "Eventi naturali" },
    { code: "27.6", description: "Eventi sociopolitici" },
    { code: "27.7", description: "Cristalli" },
    { code: "27.8", description: "Assistenza" },
    { code: "27.9", description: "Tutela legale" },
    { code: "27.10", description: "Infortuni del conducente" },
    { code: "27.11", description: "Altre garanzie" },
  ],
  rcTarifOptions: [
    { code: "28.1", description: "Bonus Malus" },
    { code: "28.2", description: "Bonus Malus con franchigia" },
    { code: "28.3", description: "Fissa" },
    { code: "28.4", description: "Fissa con pejus" },
    { code: "28.5", description: "Franchigia fissa e assoluta" },
    { code: "28.6", description: "Pejus" },
    { code: "28.7", description: "Altra forma" },
  ],
  rcGuidaOptions: [
    { code: "29.1", description: "Libera" },
    { code: "29.2", description: "Esperta" },
    { code: "29.3", description: "Esclusiva" },
  ],
  rcSatellitareOptions: [
    { code: "33.1", description: "Facoltativo" },
    { code: "33.2", description: "Obbligatorio" },
    { code: "33.3", description: "Non previsto" },
  ],
  rcRivalsaOptions: [
    { code: "38.1", description: "Per guida in stato di ebbrezza" },
    { code: "38.2", description: "Per guida sotto effetto di stupefacenti" },
    { code: "38.3", description: "Per danni subiti da terzi trasportati se il trasporto non è effettuato in conformità di legge" },
    { code: "38.4", description: "Per guida con patente scaduta" },
    { code: "38.5", description: "Per responsabilità civile per fatto di figli minori" },
    { code: "38.6", description: "Per veicolo non sottoposto a revisione" },
    { code: "38.7", description: "Per guida di neopatentati con patente da meno di un anno e veicolo di potenza eccedente il consentito" },
    { code: "38.8", description: "Non prevista" },
  ],
  kaskoCollisioneOptions: [
    { code: "56.1", description: "Collisione plafonata" },
    { code: "56.2", description: "Collisione" },
    { code: "56.3", description: "Kasko completa" },
  ],
  assistenzaTipologiaOptions: [
    { code: "85.1", description: "Autovettura sostitutiva" },
    { code: "85.2", description: "Demolizione del veicolo" },
    { code: "85.3", description: "Dépannage" },
    { code: "85.4", description: "Disbrigo delle pratiche di abbandono/dissequestro veicolo" },
    { code: "85.5", description: "Disbrigo pratiche furto" },
    { code: "85.6", description: "Ecall o segnalazione automatica per invio mezzi di soccorso" },
    { code: "85.7", description: "Invio di pezzi di ricambio" },
    { code: "85.8", description: "Invio di un autista" },
    { code: "85.9", description: "Invio di un taxi" },
    { code: "85.10", description: "Montaggio catene da neve" },
    { code: "85.11", description: "Recupero del veicolo riparato" },
    { code: "85.12", description: "Recupero del veicolo dopo il furto" },
    { code: "85.13", description: "Recupero fuoristrada del veicolo" },
    { code: "85.14", description: "Riconsegna a casa dell'auto riparata" },
    { code: "85.15", description: "Soccorso stradale" },
    { code: "85.16", description: "Rimpatrio del veicolo" },
    { code: "85.17", description: "Spese di custodia" },
    { code: "85.18", description: "Accompagnamento di minori" },
    { code: "85.19", description: "Anticipo cauzione civile" },
    { code: "85.20", description: "Anticipo cauzione penale" },
    { code: "85.21", description: "Anticipo spese di prima necessità" },
    { code: "85.22", description: "Anticipo spese legali" },
    { code: "85.23", description: "Anticipo spese mediche" },
    { code: "85.24", description: "Assistenza Domiciliare Integrata" },
    { code: "85.25", description: "Assistenza professionale domiciliare per familiare non autosufficiente" },
    { code: "85.26", description: "Consulenza medica h24" },
    { code: "85.27", description: "Consulenza psicologica" },
    { code: "85.28", description: "Supporto compilazione CAI" },
    { code: "85.29", description: "Ricerca e prenotazione centri specialistici e diagnostici" },
    { code: "85.30", description: "Interprete a disposizione all’estero" },
    { code: "85.31", description: "Invio di medicinali e/o beni di prima necessità" },
    { code: "85.32", description: "Invio di personale per assistenza animali domestici" },
    { code: "85.33", description: "Invio di un bagaglio sostitutivo" },
    { code: "85.34", description: "Invio di un infermiere o fisioterapista a domicilio" },
    { code: "85.35", description: "Invio di un medico generico" },
    { code: "85.36", description: "Invio di una baby sitter" },
    { code: "85.37", description: "Invio di una collaboratrice familiare" },
    { code: "85.38", description: "Invio di un idraulico in caso di emergenza" },
    { code: "85.39", description: "Invio di un elettricista in caso di emergenza" },
    { code: "85.40", description: "Invio di un fabbro in caso di emergenza" },
    { code: "85.41", description: "Prolungamento del soggiorno" },
    { code: "85.42", description: "Recapito messaggi urgenti" },
    { code: "85.43", description: "Reperimento di un legale" },
    { code: "85.44", description: "Rientro o proseguimento del viaggio per guasto veicolo" },
    { code: "85.45", description: "Rientro salma" },
    { code: "85.46", description: "Rientro sanitario" },
    { code: "85.47", description: "Spese di albergo" },
    { code: "85.48", description: "Trasferimento da/verso un centro ospedaliero" },
    { code: "85.49", description: "Trasporto in ambulanza" },
    { code: "85.50", description: "Viaggio di un familiare" },
    { code: "85.51", description: "Altro:" },
  ],
  tutelaLegaleTipologiaOptions: [
    { code: "91.1", description: "Spese per l'intervento di un consulente tecnico" },
    { code: "91.2", description: "Spese per l'intervento di un investigatore" },
    { code: "91.3", description: "Spese di giustizia" },
    { code: "91.4", description: "Spese giudiziali nel processo penale" },
    { code: "91.5", description: "Spese liquidate alla controparte in caso di soccombenza" },
    { code: "91.6", description: "Spese dovute alla contrroparte in caso di transazione autorizzata" },
    { code: "91.7", description: "Spese per Contributo Unificato" },
    { code: "91.8", description: "Spese per assistenza di un interprete e per traduzioni di verbali" },
    { code: "91.9", description: "Anticipo cauzione" },
    { code: "91.10", description: "Spese attinenti all'esecuzione forzata" },
    { code: "91.11", description: "Spese necessarie al dissequestro del veicolo" },
    { code: "91.12", description: "Spese per gli arbitrati per la decisione di controversie" },
    { code: "91.13", description: "Difesa in sede civile per danni extracontattuali a persone e/o a cose subiti per fatti illeciti di terzi" },
    { code: "91.14", description: "Difesa per danni causati a terzi per fatti illeciti degli assicurati" },
    { code: "91.15", description: "Difesa per sanzioni amministrative" },
    { code: "91.16", description: "Danni cagionati a trasportati o altri soggetti" },
    { code: "91.17", description: "Difesa in sede penale nei procedimenti per delitti colposi e/o per contravvenzioni" },
    { code: "91.18", description: "Difesa in sede penale nei procedimenti per reati dolosi o preterintenzionali conseguenti ad incidenti" },
    { code: "91.19", description: "Controversie di diritto civile di natura contrattuale" },
    { code: "91.20", description: "Istanza di revoca del provvedimento di sospensione/ritiro della patente, in conseguenza di incidenti da circolazione" },
    { code: "91.21", description: "Diaria per ritiro patente in un paese estero tra quelli compresi nella carta verde" },
    { code: "91.22", description: "Assistenza nei procedimenti di dissequestro del veicolo assicurato, sequestrato in seguito ad incidente stradale" },
    { code: "91.23", description: "Corso di aggiornamento per recupero punti" },
    { code: "91.24", description: "Ricorso amministrativo o giurisdizionale alle competenti autorità per errata variazione dei punti sulla patente" },
    { code: "91.25", description: "Ricorso contro l'avviso di accertamento di insufficiente o ritardato pagamento della tassa automobilistica" },
    { code: "91.26", description: "Contravvenzioni per le quali non sia ammessa oblazione in seguito ad incidenti stradali" },
    { code: "91.27", description: "Controversie relative a danni che i trasportati nel veicolo sostengano aver subito a causa dell'altrui fatto illecito" },
    { code: "91.28", description: "Consulenza legale" },
    { code: "91.29", description: "Altro:" },
  ],
  infConducenteTipologiaOptions: [
    { code: "95.1", description: "Morte da infortunio" },
    { code: "95.2", description: "Invalidità permanente da infortunio" },
    { code: "95.3", description: "Diaria da ricovero da infortunio" },
    { code: "95.4", description: "Rimborso spese mediche generiche" },
    { code: "95.5", description: "Rimborso spese mediche per grande intervento chirurgico" },
    { code: "95.6", description: "Rimborso spese mediche per ricovero o intervento chirurgico in genere" },
    { code: "95.7", description: "Infortuni in mobilità" },
    { code: "95.8", description: "Inabilità temporanea" },
    { code: "95.9", description: "Altro" },
  ],
  infInvTabellaOptions: [
    { code: "100.1", description: "Compagnia" },
    { code: "100.2", description: "ANIA" },
    { code: "100.3", description: "INAIL" },
  ],
  yesNoOptions: [
    { code: "true", description: "Sì" },
    { code: "false", description: "No" },
  ],
};

const selectChoices = {
  tariffe: { code: "", description: "" },
  compagnia: { code: "", description: "" },
  canale: [], // multiselect
  modDistribuzione: [], // multiselect
  mercato: [], // multiselect
  veicoli: { code: "", description: "" },
  prodCommercio: { code: "", description: "" },
  tipoAssicurazione: { code: "", description: "" },
  combGaranzieTipologia: { code: "", description: "" },
  premioTipologia: [], // multiselect
  frazPremio: [], // multiselect
  rischi: [], // multiselect
  rcTarif: [], // multiselect
  rcGuida: [], // multiselect
  rcSatellitare: { code: "", description: "" },
  rcRivalsa: [], // multiselect
  kaskoCollisione: [], // multiselect
  assistenzaTipologia: [], // multiselect
  tutelaLegaleTipologia: [], // multiselect
  infConducenteTipologia: [], // multiselect
  infInvTabella: { code: "", description: "" },
};

export { selectChoices };
export default data;
